module.exports = __webpack_public_path__ + "static/media/Investor-DAVE FOULKES_SUMMARY_SOLO_FINAL_1646352840695.0fc58672.vtt";